import React from "react";
import PropTypes from "prop-types";
import * as S from "./ContentSetion.Style";
import useWindowSize from "../../../hooks/useWindowSize";

const ContentSection = ({
  id,
  title,
  description,
  illustration,
  themeColor,
  reverse,
  children,
  noPadding,
  noMargin,
}) => {
  const { width } = useWindowSize();
  const isDesktop = width >= 768;

  return (
    <section
      style={{
        margin: `0 0 ${noMargin ? "0" : "4px"} 0`,
        boxShadow: "none",
        width: "100%",
        scrollMarginTop: "80px",
      }}
      id={id}
    >
      <S.SectionContainer
        themeColor={themeColor}
        reverse={reverse}
        hasContentBanner
        noPadding={noPadding}
      >
        {!isDesktop && illustration && (
          <S.Illustration>{illustration}</S.Illustration>
        )}
        <S.SectionContent width={illustration}>
          {(title || description) && (
            <div style={{ gap: "12px", display: "grid" }}>
              <S.SectionTitle>{title}</S.SectionTitle>
              {description && (
                <S.SectionParagraph>{description}</S.SectionParagraph>
              )}
            </div>
          )}
          {children}
        </S.SectionContent>
        {isDesktop && illustration && (
          <S.Illustration>{illustration}</S.Illustration>
        )}
      </S.SectionContainer>
    </section>
  );
};

export default ContentSection;

ContentSection.propTypes = {
  title: PropTypes.string,
  description: PropTypes.element,
  illustration: PropTypes.element,
  themeColor: PropTypes.string,
  noPadding: PropTypes.bool,
  noMargin: PropTypes.bool,
};

ContentSection.defaultProps = {
  title: "",
  description: "",
  illustration: "",
  themeColor: "",
  noPadding: false,
  noMargin: false,
};
